import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { HYDRATE } from 'next-redux-wrapper';
import { IHeaderProps } from '@models/Header';
import { FilterSeason } from '@enums/Filter';
import { AllShopsTypeProps } from '@services/ServiceShop/TypePromise';
interface IState {
  data: IHeaderProps;
}
const initialState: IState = {
  data: {
    headerMenu: null,
    list: null,
    region: null,
    shopsList: [],
    allShops: [],
    userAgent: null,
    regionPartner: null,
    showMobileMenu: false,
    shortHeader: false,
    season: FilterSeason.SUMMER,
    host: '',
  },
};

export const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setInitData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    setShowMobileMenu: (state, action: PayloadAction<any>) => {
      state.data.showMobileMenu = action.payload;
      action.payload ? document.body.classList.add('lock') : document.body.classList.remove('lock');
    },
    setHeaderShort: (state, action: PayloadAction<any>) => {
      state.data.shortHeader = action.payload;
    },
    setUpdateShopList: (state, action: PayloadAction<any>) => {
      state.data.shopsList = action.payload;
    },
    setAllShops: (state, action: PayloadAction<AllShopsTypeProps[]>) => {
      state.data.allShops = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.header,
      };
    },
  },
});

export const { setInitData, setHeaderShort, setShowMobileMenu, setAllShops } = headerSlice.actions;

export const selectHeaderData = (state: RootState) => state.header.data;
export const selectUserAgent = (state: RootState) => state.header.data.userAgent;
export const selectRegion = (state: RootState) => state.header.data.region;
export const getAllShops = (state: RootState) => state.header.data.allShops;
